var _a;
import Vue from 'vue';
var _watcher, _dep, Watcher, Dep;
var computedKey = 'c';
var vm = new Vue({
    computed: (_a = {},
        _a[computedKey] = function () {
            return 1;
        },
        _a)
});
_watcher = vm._computedWatchers[computedKey];
_dep = vm._data.__ob__.dep;
Watcher = Object.getPrototypeOf(_watcher).constructor;
Dep = Object.getPrototypeOf(_dep).constructor;
vm.$destroy();
export { Watcher, Dep };
